/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames/bind.js';
import proptypes from 'prop-types';
const { bool, oneOfType, array, string } = proptypes;

import styles from './SeoCopyBlock.module.scss';

const cx = classNames.bind(styles);

const SeoBoldText = ({ children, isBlock = false }) => {
  const Element = isBlock ? 'p' : 'span';

  return (
    <Element className={cx('seoCopyBlockBoldText')}>
      {children}
    </Element>
  );
};

SeoBoldText.propTypes = {
  isBlock: bool,
  children: oneOfType([array, string]).isRequired
};

export default SeoBoldText;
